export type RankField = {
  score: number | null
  from: string | number | null
  to: string | number | null
}

export type IntegrationCodeMatch = {
  provider: string
  integration_code_value: string
  score: number
  name: string | null
  image_url?: string
  rank_fields: Record<string, RankField>
}

export const integrationCodeMatchKey = (match: { provider: string; integration_code_value: string }) =>
  `${match.provider}::${match.integration_code_value}`
